<template>
    <svg
        :width="width" :height="height"
        version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 484.2 79.1" style="enable-background:new 0 0 484.2 79.1;" xml:space="preserve">

        <g id="Ebene_1">
	<g>
		<polygon class="svg-primary-color" points="24.8,14.5 26.6,13.5 69.8,45.5 69.1,47.7 47.9,47.7 56.1,62.5 56.1,55.1 79.8,55.1 79.8,23.4
			56.1,23.4 56.1,0 24.8,0 24.8,14.5 		"/>

        <polygon class="svg-outline-color" points="39.2,52.6 50.6,73.7 56.1,70.6 56.1,79.1 24.7,79.1 24.8,67.5 26.9,68.3 39.2,52.6 		"/>
        <polygon class="svg-outline-color" points="0,23.5 24.8,23.5 24.8,55.4 0,55.4 0,23.5 		"/>
	</g>
            <g>
		<path class="svg-outline-color" d="M94.4,23.3h4.3v31.9h-4.3V23.3z"/>
                <path class="svg-outline-color" d="M105.9,23.3h6.4l29.2,28v-28h4.3v31.9h-6.4l-29.2-28v28h-4.3V23.3z"/>
                <path class="svg-outline-color" d="M152.6,43.4l26.2-20.2h5.9v21.7h5.3v3.5h-5.3v6.7h-4v-6.7h-28V43.4z M180.6,26.3l-24,18.5v0.1h24V26.3z"/>

                <path class="svg-primary-color" d="M197,23.3h6.7L222.3,50L241,23.3h6.7v31.9h-4.3v-28h-0.1l-19.4,28h-3.1l-19.4-28h-0.1v28H197V23.3z"/>
                <path class="svg-primary-color" d="M254.9,23.3h31.3v3.5h-27v10.2h25.9v3.5h-25.9v11.1h27.2v3.5h-31.5V23.3z"/>
                <path class="svg-primary-color" d="M292.3,23.3h25.7c10.7,0,13.6,3.3,13.6,15.9c0,11.7-2.9,15.9-13.7,15.9h-25.6V23.3z M327.3,37.7
			c0-9.2-2.9-10.9-8.1-10.9h-22.6v24.8h21.9c5.2,0,8.8-1.1,8.8-10.7V37.7z"/>
                <path class="svg-primary-color" d="M338.3,23.3h4.3v31.9h-4.3V23.3z"/>
                <path class="svg-primary-color" d="M349.4,34.8c0-8.1,2.7-11.9,11.4-11.9h16.5c7.8,0,10,3.7,10,7.9v2.7h-3.8v-1.5c0-5.4-3.3-5.7-7.3-5.7h-15
			c-4.1,0-7.5,1.2-7.5,6.8v12c0,5.5,3.3,6.8,7.5,6.8h15.1c5.8,0,7.5-1.2,7.5-5.5v-2h4v2.2c0,5.8-1.8,8.9-10.8,8.9h-16.3
			c-8.6,0-11.4-3.9-11.4-11.9V34.8z"/>
                <path class="svg-primary-color" d="M394.1,23.3h4.3v31.9h-4.3V23.3z"/>
                <path class="svg-primary-color" d="M405.5,23.3h6.4l29.2,28v-28h4.3v31.9H439l-29.2-28v28h-4.3V23.3z"/>
                <path class="svg-primary-color" d="M452.7,23.3H484v3.5h-27v10.2h25.9v3.5H457v11.1h27.2v3.5h-31.5V23.3z"/>
	</g>
</g>
        <g id="Ebene_2">
</g>
</svg>

</template>

<script>
export default {
    name: "in4MedicineLogo",
    props: {
        width: {
            type: Number,
            default: 145
        },
        height: {
            type: Number,
            default: 24
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/in4MedicineLogo.vue